import { NavLink } from "react-router-dom";
import { Box, Heading, Text, Button, IconButton } from "@chakra-ui/react";
import { BiArrowBack } from "react-icons/bi";
import { useLocation } from "react-router-dom";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useTranslation } from "react-i18next";
import { routeTo } from "@/router/routeTo";
import { useAuth } from "@/hooks/useAuth";
import { useSafeBackNavigation } from "@/hooks/useSafeBackNavigation";


const Error404 = () => {
  const { t } = useTranslation(['errors'])
  useDocumentTitle(t('404.title'));
  const { isAuthenticated } = useAuth();

  const location = useLocation()

  const goBack = useSafeBackNavigation();

  return (
    <Box>
      <Box>
        <Box>
          <Text as="p">Error 404</Text>
          <Heading as="h1">Page not found</Heading>
        </Box>
        <Text as="p">Sorry, the page you are looking for doesn't exist or has been moved.</Text>
      </Box>
      <Box>
        <IconButton onClick={goBack}>
          <BiArrowBack />
          Go Back
        </IconButton>
        <NavLink to={isAuthenticated ? routeTo.dashboard() : routeTo.root()} state={{ from: location }}>
          <Button>
            Take me home
          </Button>
        </NavLink>
      </Box>
    </Box>
  );
};

export default Error404;